import {
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Backdrop,
  CircularProgress,
  Box,
  Paper,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { useNotification } from "../../hooks/useNotification";
import useStyles from "../../themes/style.js";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import uploadPictureLogo from "../../images/png/upload-picture.png";
import getCroppedImg from "../../utils/croppedImage.js";
import Cropper from "react-easy-crop";
import CloseIcon from "@material-ui/icons/Close";
import { useUserDetails } from "../../context/UserDataContext.js";

const UpdateLogo = ({ logoDetails }) => {
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const handleNotificationCall = useNotification();
  const {profileMenuName,fetchViewUsersData} = useUserDetails();
  const [loader, setLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);
  const [uploadStatus, setUploadStatus] = useState("");

  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImgae, setCroppedImage] = useState(null);

  const [changeImage, setChangeImage] = useState("");
  const [imageSrc, setImageSrc] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => {
    setShowModal(false);
    setCroppedImage(null);
    setImageSrc(null);
    setChangeImage("")
  };

  const onCropComplete = useCallback(
    async (croppedArea, croppedAreaPixels) => {
      const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
      setCroppedAreaPixels(croppedAreaPixels);
      const reader = new FileReader();
      reader.readAsDataURL(croppedImageBlob);
      reader.onloadend = () => {
        setCroppedImage(reader.result); // This will be a base64 data URL
      };
    },
    [imageSrc],
  );

  const handleFileChange = (e, imgType) => {
    setSelectedFile(e.target.files[0]);
    const file = e.target.files[0];

    if (!file) {
      handleNotificationCall("error", "Upload Failed");
      return;
    }

    const reader = new FileReader();
    reader.addEventListener("load", () => setImageSrc(reader.result));
    reader.readAsDataURL(file);
    setChangeImage(imgType);
    setShowModal(true);
    // handleUpload(file,imgType);
  };

  const handleUpload = async () => {
    const fileFormat = ["png", "jpg", "jpeg"];
    setLoader(true);
    if (!selectedFile) {
      setUploadStatus("Please select a file to upload.");
      return;
    }
    if (!croppedAreaPixels || !imageSrc) return;
    const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);

    if (croppedImageBlob.size > 3 * 1024 * 1024) {
      alert("The cropped image size exceeds 3MB. Please crop again.");
      return;
    }
    const timeStamp = Date.now()

    // Convert Blob to File
    const croppedImageFile = new File([croppedImageBlob], `${timeStamp}.jpg`, {
      type: croppedImageBlob.type,
    });

    // const fileName = file.name.split(".").pop();
    // if (!fileFormat.includes(fileName)) {
    //   handleNotificationCall("error", "Invalid File Format");
    //   return;
    // }

    const formData = new FormData();
    changeImage === "LOGOIMAGE"
      ? formData.append("image", croppedImageFile)
      : formData.append("image_secondary", croppedImageFile);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/setLogo`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        },
      );
      setLoader(false);
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        setShowModal(false);
        setChangeImage("");
        fetchViewUsersData();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error)
    }
  };

  return (
    <Card className={classes.root}>
      <CardContent className={classes.root}>
        <Grid container direction="row" spacing={4}>
          <Grid item xs={12}>
            <Typography variant="subtitle1">Update LOGO</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            {logoDetails?.image !== process.env.REACT_APP_AWS_BUCKET_URL ? (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                width="100%"
                mt={2}
              >
                {/* Drag and Drop Zone */}
                <Paper
                  variant="outlined"
                  style={{
                    width: "100%",
                    padding: "20px",
                    border: "2px dashed #A6AEBF",
                    background: "#f9f8f8",
                    textAlign: "center",
                    marginRight: "10px",
                  }}
                >
                  <img
                    src={logoDetails?.image}
                    alt="upload-pic"
                    style={{ width: "325px" }}
                    className="img-fluid"
                    width="100%"
                  />
                  {/* <CloudUpload style={{ fontSize: "50px", color: "#1976d2" }} /> */}

                  <Typography
                    variant="body2"
                    style={{
                      fontStyle: "italic",
                      color: "#758694",
                      margin: "15px 0px",
                    }}
                  >
                    (PNG, JPG, JPEG Formats Only)
                  </Typography>

                  <Button variant="contained" color="primary" component="label">
                    Edit Logo
                    <input
                      type="file"
                      hidden
                      accept=".png,.jpg,.jpeg"
                      onChange={(e) => handleFileChange(e, "LOGOIMAGE")}
                    />
                  </Button>
                </Paper>
                {uploadStatus && (
                  <Typography variant="body2" color="secondary">
                    {uploadStatus}
                  </Typography>
                )}
              </Box>
            ) : (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                width="100%"
                mt={2}
              >
                {/* Drag and Drop Zone */}
                <Paper
                  variant="outlined"
                  style={{
                    width: "100%",
                    padding: "20px",
                    border: "2px dashed #A6AEBF",
                    background: "#f9f8f8",
                    textAlign: "center",
                    marginRight: "10px",
                  }}
                >
                  <img
                    src={uploadPictureLogo}
                    alt="upload-pic"
                    style={{ width: "180px" }}
                    className="img-fluid"
                    width="100%"
                  />
                  {/* <CloudUpload style={{ fontSize: "50px", color: "#1976d2" }} /> */}

                  <Typography variant="body2">Upload Profile Logo</Typography>
                  <Typography
                    variant="body2"
                    style={{ fontStyle: "italic", color: "#758694" }}
                  >
                    (PNG, JPG, JPEG Formats Only)
                  </Typography>

                  <Button
                    variant="contained"
                    color="primary"
                    component="label"
                    style={{ marginTop: "10px" }}
                  >
                    Upload File
                    <input
                      type="file"
                      hidden
                      accept=".png,.jpg,.jpeg"
                      onChange={(e) => handleFileChange(e, "LOGOIMAGE")}
                    />
                  </Button>
                </Paper>
                {uploadStatus && (
                  <Typography variant="body2" color="secondary">
                    {uploadStatus}
                  </Typography>
                )}
              </Box>
            )}
          </Grid>
          <Grid item xs={12} md={8}>
            {logoDetails?.image_secondary !== process.env.REACT_APP_AWS_BUCKET_URL ? (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                width="100%"
                mt={2}
              >
                <Paper
                  variant="outlined"
                  style={{
                    width: "100%",
                    padding: "20px",
                    border: "2px dashed #A6AEBF",
                    background: "#f9f8f8",
                    textAlign: "center",
                    marginRight: "10px",
                  }}
                >
                  <img
                    src={logoDetails?.image_secondary}
                    style={{ minWidth: "200px",maxWidth:"550px" }}
                    alt="upload-pic"
                    className="img-fluid"
                    width="100%"
                  />
                  <Typography
                    variant="body2"
                    style={{
                      fontStyle: "italic",
                      color: "#758694",
                      margin: "15px 0px",
                    }}
                  >
                    (PNG, JPG, JPEG Formats Only)
                  </Typography>

                  <Button variant="contained" color="primary" component="label">
                    Edit Document Logo
                    <input
                      type="file"
                      hidden
                      accept=".png,.jpg,.jpeg"
                      onChange={(e) => handleFileChange(e, "DOCLOGOIMAGE")}
                    />
                  </Button>
                </Paper>
                {uploadStatus && (
                  <Typography variant="body2" color="secondary">
                    {uploadStatus}
                  </Typography>
                )}
              </Box>
            ) : (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                width="100%"
                mt={2}
              >
                <Paper
                  variant="outlined"
                  style={{
                    width: "100%",
                    padding: "20px",
                    border: "2px dashed #A6AEBF",
                    background: "#f9f8f8",
                    textAlign: "center",
                    marginRight: "10px",
                  }}
                >
                  <img
                    src={uploadPictureLogo}
                    style={{ width: "180px" }}
                    alt="upload-pic"
                    className="img-fluid"
                    width="100%"
                  />

                  <Typography variant="body2">Upload Document Logo</Typography>
                  <Typography
                    variant="body2"
                    style={{ fontStyle: "italic", color: "#758694" }}
                  >
                    (PNG, JPG, JPEG Formats Only)
                  </Typography>

                  <Button
                    variant="contained"
                    color="primary"
                    component="label"
                    style={{ marginTop: "10px" }}
                  >
                    Upload File
                    <input
                      type="file"
                      hidden
                      accept=".png,.jpg,.jpeg"
                      onChange={(e) => handleFileChange(e, "DOCLOGOIMAGE")}
                    />
                  </Button>
                </Paper>
                {uploadStatus && (
                  <Typography variant="body2" color="secondary">
                    {uploadStatus}
                  </Typography>
                )}
              </Box>
            )}
          </Grid>
        </Grid>
      </CardContent>

      <Dialog
        aria-labelledby="dialog-title"
        open={showModal}
        maxWidth="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
        onClose={handleModalClose}
      >
        <DialogContent>
          <div
            className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}
          >
            <Typography variant="subtitle2" className={classes.inputRoot}>
              Crop Image ({changeImage === "LOGOIMAGE" ? "1:1"  : "16:9"})
            </Typography>

            <div className={classes.pdfModalCloseBtn}>
              <CloseIcon className={classes.closeBtn} onClick={handleModalClose} />
            </div>
          </div>
          <div
            className="d-flex"
            style={{ position: "sticky", minHeight: "50vh" }}
          >
            {imageSrc && (
              <div className="crop-container">
                <Cropper
                  image={imageSrc}
                  crop={crop}
                  zoom={zoom}
                  aspect={changeImage === "LOGOIMAGE" ? 1 : 16 / 9}
                  onCropChange={setCrop}
                  onCropComplete={onCropComplete}
                  onZoomChange={setZoom}
                />
              </div>
            )}
          </div>
          <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={handleModalClose}
            >
              Close
            </Button>
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={handleUpload}
            >
              Crop
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Card>
  );
};

export default UpdateLogo;
